import { LANG_OPTIONS } from '@/common/constants/languages';

const STRIPE_COUNTRY_BY_LANG = {
	[LANG_OPTIONS.polish]: 'PL',
	[LANG_OPTIONS.german]: 'DE',
	[LANG_OPTIONS.czech]: 'CZ',
	[LANG_OPTIONS.english]: 'US',
};

const STRIPE_CURRENCY_BY_LANG = {
	[LANG_OPTIONS.polish]: 'pln',
	[LANG_OPTIONS.german]: 'eur',
	[LANG_OPTIONS.czech]: 'czk',
	[LANG_OPTIONS.english]: 'usd',
};

export const getStripeCountryByLang = (lang) =>
	STRIPE_COUNTRY_BY_LANG[lang] ?? STRIPE_COUNTRY_BY_LANG[LANG_OPTIONS.english];

export const getStripeCurrencyByLang = (lang) =>
	STRIPE_CURRENCY_BY_LANG[lang] ?? STRIPE_CURRENCY_BY_LANG[LANG_OPTIONS.polish];
